/* global ppd */

import moment from 'moment'

export const SERVER_DATE_FORMAT = 'yyyy/mm/dd'

export const formatDate = (dateString, format) => {
  if (!dateString) { return '' }
  try {
    const date = new Date(dateString.replace(/\s[+-]\d{4}/, ''))
    if (isNaN(date.getTime())) { return dateString }
    return date.format(format || ppd.dateFormat)
  } catch (e) {
    return ''
  }
}

export const formatTime = (dateString) => {
  return formatDate(dateString, ppd.timeFormat)
}

export const formatTimeAgo = (dateTimeString) => moment(dateTimeString).fromNow()

export const formatDateTime = (dateString, joiner = '') => {
  return `${formatDate(dateString)} ${joiner} ${formatTime(dateString)}`
}

export const daysSinceNow = (dateString, sinceDateString) => {
  try {
    const now = sinceDateString ? new Date(sinceDateString) : new Date()
    const created = new Date(dateString)
    const oneDayInMs = 24 * 60 * 60 * 1000
    const ageInDaysFloat = Math.abs((now.getTime() - created.getTime()) / (oneDayInMs))
    const ageInDays = Math.floor(ageInDaysFloat)
    return ageInDays
  } catch (e) {
    return 0
  }
}

export const daysSince = daysSinceNow

export const isPastDue = (date) => {
  return moment(date) < moment().startOf('day')
}
